import { useDividas } from "../../../../../context/DividasContext";
// import { useFila } from "../../../../../context/FilaContext";
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ";

export const ClienteInfo = () => {
  const { devedor } = useDividas()
  // const { devedorFilaSelected } = useFila()
  return (
    <div className="my-4 flex w-full items-center gap-8 ">
      <p>
        <strong className="font-medium text-gray-800">Nome: </strong> {devedor?.name && devedor?.name.toUpperCase()}
      </p>
      <p>
        <strong className="font-medium text-gray-800">CPF/CNPJ: </strong>
        {devedor?.cpf_cnpj && formatCPFCNPJ(devedor?.cpf_cnpj)}
      </p>
    </div>
  );
};
